import axios from "axios";

export function getAutoavaliacaoCampos() {
    return axios.get("/autoavaliacao-campo");
}

export function getAutoavaliacaoCamposApagados() {
    return axios.get("/autoavaliacao-campo?show_deleted=true");
}

export function syncAutoavaliacaoCampos(campos: any[]) {
    return axios.put("/autoavaliacao-campo/sync", campos);
}

export function undeleteAutoavaliacaoCampo(id: number) {
    return axios.patch(`/autoavaliacao-campo/${id}/undelete`);
}

export function hardDeleteAutoavaliacaoCampo(id: number) {
    return axios.delete(`/autoavaliacao-campo/hard/${id}`);
}